import { IAdressInterface } from '../modules/types/paymentInfo';

export function isBillingAddressFilled(billingAddress: IAdressInterface): boolean {
  if (!billingAddress) return false;

  const requiredFields: (keyof IAdressInterface)[] = [
    'city',
    'company',
    'country',
    'email',
    'firstName',
    'lastName',
    'street',
    'zipcode',
    'streetNumber'
  ];

  return requiredFields.every((field) => Boolean(billingAddress[field]));
}
